<template>
  <div>
    <v-toolbar flat color="white" class="pt-3">
      <h2 class="dark-grey--text px-2">Module: {{moduleInfo.name}}</h2>
      <v-spacer></v-spacer>
      <v-text-field label="Search" v-model="search"></v-text-field>
      <v-btn
        v-if="initialSubmodules!==submodules"
        round
        color="primary"
        @click="saveChanges"
      >Save Changes</v-btn>
    </v-toolbar>

    <v-toolbar flat color="white">
      <v-tabs  div="tabs">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          href="#"
          v-model="tabs"
          v-for="tab in tabs"
          :key="tab.name"
          @click="setActiveTabName(tab.name)"
        >{{tab.displayName}}</v-tab>
      </v-tabs>
    </v-toolbar>
    <div v-if="displayContents('submodules')">
      <v-data-table
        :headers="headers"
        class="elevation-1"
        :items="allSubmodules"
        :search="search"
        v-model="submodules"
        item-key="id"
        align-center
        select-all
        style="cursor: pointer"
      >
        <template v-slot:items="props">
          <!-- <td class="text-xs-center">
            <v-icon small @click="deleteItem(props.item)">delete</v-icon>
          </td>-->
          <td>
            <v-checkbox id="checkBoxId" v-model="props.selected" primary hide-details></v-checkbox>
          </td>
          <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.name}}</td>
          <td
            @click="routerLinkToDetails(props.item)"
            class="text-xs-center"
          >{{props.item.description}}</td>
        </template>
        <template
          v-slot:pageText="props"
        >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import Api from "@/services/Api";

export default {
  data() {
    return {
      moduleInfo: null,
      submodules: [],
      allSubmodules: [],
      initialSubmodules: [],
      foreignKey: [],
      orgs: [],
      search: "",
      tabs: [{ name: "submodules", displayName: "submodules" }],
      headers: [
        //         {
        //   text: "Action",
        //   align: "center"
        // },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Description",
          align: "center",
          value: "description"
        }
      ]
    };
  },

  created() {
    this.initialize();
    this.setActiveTabName("submodules");
  },
  async mounted() {
    this.setActiveTabName("submodules");
  },

  methods: {
    fetchSubmodules() {
      Api()
        .get("/submodules")
        .then(response => {
          this.allSubmodules = response.data;
        });
    },
    fetchModuleInfo() {
      this.submodules = [];
      this.initialSubmodules = [];
      this.foreignKey = [];
      Api()
        .get("/modules/" + this.$route.params.moduleId)
        .then(response => {
          this.moduleInfo = response.data;
          let moduleSubmodules = response.data.moduleSubmodules;
          for (let i = 0; i < moduleSubmodules.length; i++) {
            if (!moduleSubmodules[i].isDeleted) {
              this.submodules.push(moduleSubmodules[i].submodule);
              this.initialSubmodules.push(moduleSubmodules[i].submodule);
              this.foreignKey.push({
                id: moduleSubmodules[i].id,
                subModuleId: moduleSubmodules[i].submodule.id
              });
            }
          }
          // this.submodules=response.data.moduleSubmodule.submodules
          // this.initialSubmodules=response.data.submodules
        });
    },

    displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },

    initialize() {
      this.fetchSubmodules();
      this.fetchModuleInfo();
    },
    async saveChanges() {
      await Api()
        .get("/organisationModule/byModule/" + this.$route.params.moduleId+'/admin')
        .then(res => {
          // this.orgs = [];
          // for (let i = 0; i < res.data.length; i++) {
          //   if (
          //     res.data[i].organisation.isActive &&
          //     !res.data[i].organisation.isDeleted &&
          //     !this.orgs.includes(res.data[i].organisation)
          //   ) {
          //     this.orgs.push(res.data[i].organisation);
          //   }
          // }
          this.orgs = [...new Set(res.data.map(x=>x.organisation.id))]
        });
      for (let i = 0; i < this.submodules.length; i++) {
        if (this.initialSubmodules.indexOf(this.submodules[i]) === -1) {
          await Api()
            .post("/moduleSubmodule", {
              moduleId: this.$route.params.moduleId,
              submoduleId: this.submodules[i].id,
              isActive: true,
              isDeleted: false
            })
            .then(response => {
              Api()
                .get("/userRole/admin")
                .then(async result => {
                  let batch = []
                  for (let y = 0; y < this.orgs.length; y++) {
                    for (let i = 0; i < result.data.length; i++) {
                      if (result.data[i].isAdmin) {
                        await batch.push({
                          organisationId: this.orgs[y],
                          moduleSubmoduleId: response.data.id,
                          userRoleId: result.data[i].id,
                          admin: true,
                          create: true,
                          read: true,
                          update: true,
                          delete: true
                        })
                        // await Api().post("/routePermission", {
                        //   organisationId: this.orgs[y],
                        //   moduleSubmoduleId: response.data.id,
                        //   userRoleId: result.data[i].id,
                        //   admin: true,
                        //   create: true,
                        //   read: true,
                        //   update: true,
                        //   delete: true
                        // });
                      } else {
                        await batch.push({
                          organisationId: this.orgs[y],
                          moduleSubmoduleId: response.data.id,
                          userRoleId: result.data[i].id,
                          admin: false,
                          create: false,
                          read: false,
                          update: false,
                          delete: false
                        })
                        // await Api().post("/routePermission", {
                        //   organisationId: this.orgs[y],
                        //   moduleSubmoduleId: response.data.id,
                        //   userRoleId: result.data[i].id,
                        //   admin: false,
                        //   create: false,
                        //   read: false,
                        //   update: false,
                        //   delete: false
                        // });
                      }
                    }
                  }
                  await Api().post("/routePermission", {
                          batch: batch
                        });
                });
            });
        }
      }
      for (let x = 0; x < this.initialSubmodules.length; x++) {
        console.log(this.initialSubmodules);
        console.log(this.submodules);
        if (this.submodules.indexOf(this.initialSubmodules[x]) === -1) {
          let subModuleId = this.initialSubmodules[x].id;
          let foreignKeyId = this.foreignKey.filter(function(el) {
            return el.subModuleId === subModuleId;
          });
          await Api()
            .put("/moduleSubmodule/" + foreignKeyId[0].id, {
              isActive: false,
              isDeleted: true
            })
            .then(response => {
              Api()
                .get("/routePermission")
                .then(async result => {
                  let changes = result.data.filter(function(el) {
                    return el.moduleSubmoduleId === foreignKeyId[0].id;
                  });
                  for (let i = 0; i < changes.length; i++) {
                    await Api().put("/routePermission/" + changes[i].id, {
                      isActive: false,
                      isDeleted: true
                    });
                  }
                });
            });
        }
      }
      this.fetchModuleInfo();
    }
  }
};
</script>
<style>
.Planned {
  border-left: solid #d61212;
}
.Ongoing {
  border-left: 4px solid #eb780c;
}
.Complete {
  border-left: 4px solid #5eb110;
}
.Live {
  border-left: 4px solid #5eb110;
}
</style>
